<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <!-- 左侧菜单 -->
    <sidebar class="sidebar-container" />
    <div :class="{ hasTagsView: true }" class="main-container">
      <div :class="{ 'fixed-header': false }">
        <!-- 顶部菜单 -->
        <navbar />
        <!-- 顶部菜单选卡 -->
      </div>
      <tags-view />
      <div class="back">
        <div class="container">
          <!-- 主内容 -->
          <app-main />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 顶部菜单 / 左侧菜单 / 菜单选卡 / 主内容
import { Navbar, Sidebar, TagsView, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  mixins: [ResizeMixin],
  data() {
    return {
      notifyList: [],
      isChart: false,
      userCode: this.$store.getters['user/getUserCode']
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    showAll() {
      return this.$store.state.tagsView.openChart
    }
  },
  created() {
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  background-image: url("../assets/list/background.png");
  background-repeat: no-repeat;
  background-size: cover;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px)
}

.mobile .fixed-header {
  width: 100%;
}

.back {
  background-color: transparent;
  padding: 16px 20px 20px 0;

  .container {
    border-radius: 6px 6px 6px 6px;
    background-color: #ffffff;
    overflow: hidden;
  }
}

// 修改element 组件样式
::v-deep .el-notification__group {
  width: 100% !important;
}

::v-deep .el-form--inline .el-form-item {
  margin-right: 0 !important;
}

::v-deep .el-collapse-item__content {
  position: relative;
  left: 0;
  top: 0;
}

//::v-deep .el-input-number {
//  line-height: 36px;
//}
//
//::v-deep .el-input__inner {
//  line-height: 38px;
//  height: 38px;
//}
</style>
